export default function ChangeUser(id, type, fio) {
    return {
        type: 'HISTORY_ACTION',
        payload: {
            user: {
                id, type, fio
            },
            history: []
        }
    };
}



/** WEBPACK FOOTER **
 ** ./src/modules/food/actions/history/ChangeUser.js
 **/